import { useEffect, useMemo, useRef } from 'react';
/**
 * Easily transform the data of a query result.
 * * @param query - The query result to select from.
 * @param selector - The selector function to apply to the query result.
 * @returns A new query result with the selected data.
 */
export function useQuerySelector(query, selector = d => d) {
  const sref = useRef(selector);
  useEffect(() => {
    sref.current = selector;
  });
  return useMemo(() => Object.assign({}, query, {
    data: sref.current(query.data)
  }), [query]);
}